import { createFileRoute } from '@tanstack/react-router'

import { getListUsersOptions, preloadGetMe, preloadListInvites } from '@/api/react-query'

export const Route = createFileRoute('/_authenticated/settings/users')({
	loader: async ({ context }) => {
		await Promise.all([
			preloadGetMe(context, {}),
			context.queryClient.prefetchQuery(getListUsersOptions(context.api, {})),
			preloadListInvites(context, {})
		])
	},
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.Users.Title()
	}
})
